<template>
  <div class="flex items-center justify-center h-full flex-col">
    <div class="flex items-center  type-scale-5 text-gray-80">
      <i class="material-icons mr-4">{{ icon }}</i>
      <slot />
    </div>
    <p class="text-gray-50"><slot name="helper" /></p>
  </div>
</template>

<script>
export default {
  name: 'AppEmptyState',

  props: {
    icon: String
  }
}
</script>
